import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TShopsApi } from './types';

export const shops: TShopsApi = {
	getShops: (payload) =>
		http.get(endpoint.shops.SHOPS, { params: payload }).then((response) => response.data),
	getShopGoods: (payload) =>
		http.post(endpoint.shops.SHOP_GOODS, payload).then((response) => response.data),
	addShop: (payload) =>
		http.post(endpoint.shops.ADD_SHOP, payload).then((response) => response.data),
	deleteShop: (shopId) => http.delete(endpoint.shops.DELETE_SHOP(shopId)),
	getShopAttributesForm: (shopId) =>
		http.get(endpoint.shops.SHOP_ATTRIBUTES_FORM(shopId)).then((response) => response.data),
	updateShopAttributes: (payload) =>
		http.post(endpoint.shops.SHOP_ATTRIBUTES(payload.shopId), payload.attributes),
	migrateShop: (shopId) =>
		http.post(endpoint.shops.SHOP_MIGRATE(shopId)).then((response) => response.data),
	getShopMigrationStatus: (shopId) =>
		http.get(endpoint.shops.SHOP_MIGRATION_STATUS(shopId)).then((response) => response.data),
	restartShopMigration: (shopId) =>
		http.post(endpoint.shops.SHOP_MIGRATION_RESTART(shopId)).then((response) => response.data),
};
